<template>
  <v-app style="background-color: #e5e5e5">
    <router-view></router-view>
  </v-app>
</template>
<script>
export default {
  name: "app",
  data() {
    return {
      requiredAuth: false,
    };
  },
  created() {
    this.requiredAuth = localStorage.getItem("requiresAuth");
  },
  mounted() {
  
    if (this.requiredAuth === "true") {
      this.toast("برای رفتن به این صفحه ابتدا باید وارد شوید", "error");
      localStorage.setItem("requiresAuth", null);
    }
  },
};
</script>
<style lang="scss">

@media screen and (max-width: 800px){
  .v-responsive__content {
    -webkit-box-flex: 1;
    -ms-flex: 1 0 0px;
    flex: 1 0 0px;
    max-width: 100%;
    display: flex;
    justify-content: center;
  }
  .v-window__next, .v-window__prev {

    margin: 0 !important;

  }
}
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
// Import Main styles for this application
@import "assets/scss/style";

@font-face {
  font-family: "iranyekan";
  src: url("../src/assets/fonts/iranyekan/iranyekanwebbold.ttf");
  src: url("../src/assets/fonts/iranyekan/iranyekanweblight.ttf");
  src: url("../src/assets/fonts/iranyekan/iranyekanwebregular.ttf");
  src: url("../src/assets/fonts/iranyekan/IRANYekanLightMobile(FaNum).ttf");
  src: url("../src/assets/fonts/iranyekan/IRANYekanMobileBold(FaNum).ttf");
  src: url("../src/assets/fonts/iranyekan/IRANYekanRegularMobile(FaNum).ttf");
}

* {
  font-family: "iranyekan";
}

// .inputPrice >>> input[type="number"] {
//   -moz-appearance: textfield;
// }
// .inputPrice >>> input::-webkit-outer-spin-button,
// .inputPrice >>> input::-webkit-inner-spin-button {
//   appearance: none;
//   -webkit-appearance: none;
//   -moz-appearance: none;
// }
/* width */

</style>
